



















































































































import { ExportAllItensUseCase, FindImportacaoUseCase, ImportaItensUseCase } from '@/usecases';
import { Component, Vue } from 'vue-property-decorator';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { uploadFilesToS3 } from '@/shareds/s3/files';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';

@Component
export default class DialogoDeCsvTabelaDePrecos extends Vue {
	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
		{ action:'Exportar', icon: 'mdi-file-download' },
	]
	exportAllItensUseCase = new ExportAllItensUseCase()
	importaItensUseCase = new ImportaItensUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()
	importando = false
	exportando = false
	arquivoContemCabecalho = false
	arquivoCsv: File[] = []
	tabelaNome: string | null = null
	tabelaId: string | null = null
	selecionado: boolean | null = null
	importarComProdutoPai = false

	async mostrar(tabelaId?: string, tabelaNomeRecebido?: string){
		this.tabelaId = tabelaId ? tabelaId : null
		this.tabelaNome = tabelaNomeRecebido ? tabelaNomeRecebido : null
		
		this.mostra = true
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = []
		this.arquivoContemCabecalho = false
		this.importarComProdutoPai = false
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async concluirImportacao() {
		if (this.arquivoCsv.length == 0) {
			return AlertModule.setError("É obrigatório selecionar um arquivo");
		}
		if (!this.tabelaId) {
			return;
		}

		if(!this.usuario) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.importando = false;
				return
			}
		}

		try {
			this.importando = true;

			const informacoesDosArquivos = await uploadFilesToS3(
				this.arquivoCsv,
				`importacao-tabela-de-preco`,
			);
			const urlDoArquivo = informacoesDosArquivos.map(({ config }) => config.url)[0];

			if (!urlDoArquivo) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
			}

			await this.importaItensUseCase.execute(
				this.tabelaId,
				this.arquivoContemCabecalho,
				this.importarComProdutoPai,
				urlDoArquivo,
			);

			AlertModule.setSuccess('Itens em processamento');
			this.$emit('concluiuImportacao');
		} catch (e) {
			this.importando = false;
			AlertModule.setError(e);
		} finally {
			this.importando = false;
			this.arquivoCsv = [];
			this.mostra = false;
			this.arquivoContemCabecalho = false;
			this.importarComProdutoPai = false
		}
	}

	baixarModelo() {
		const rows = [
			[
				'sku', 'precoCompra', 'margemLucro', 'descontoVarejo', 'precoFinalVarejo', 'inicioVigencia', 'fimVigencia', 'limitarProduto', 'qtdeLimitadaDoProduto', 'percentualCashback', 'diasParaEfetuarCashback',
			],
			[
				'ABC123GGBRANCO', '50,00', '100,00', '10,00', '150,00', '01/01/2026', '31/12/2026', 'false', '0', '0', '0',
			],
			[
				'ABC123GGPRETO', '40,00', '120,00', '5,00', '99,90', '01/01/2026', '31/12/2026', 'true', '10', '5,00', '15',
			],
			[
				'789XYZ', '', '35,00', '0,00', '89,90', '', '', '', '', '', '',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8,"
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_importacao_tabela_de_preco.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	async exportarCsv() {
		if(!this.tabelaId) return
		try {
			AlertModule.setSuccess('O arquivo está sendo gerado. O processo pode levar alguns minutos.')
			const response: any = await this.exportAllItensUseCase.exportAllItens(this.tabelaId)
			const url = window.URL.createObjectURL(new Blob([response]));
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', `precos_${this.tabelaNome}.csv`)
			document.body.appendChild(link)
			link.click()
		} catch (e) {
			AlertModule.setError(e)
		} 
	}
}
